import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class NtapsServiceTypesRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/shipping/ntaps/service_types');
    }

    async getAll() {
        if (Cache.get('ntaps-service-types')) {
            return Cache.get('ntaps-service-types');
        }

        return this.run().then((res) => {
            Cache.set('ntaps-service-types', res, 60 * 15 * 1000);
            return Cache.get('ntaps-service-types');
        });
    }
}
